<template>
  <artmisads-modal
    :open="true"
    :title=title
    :width="720"
    :onCancel="() => props.setShowModal(false)"
    :destroyOnClose="true"
  >
    <a-spin :spinning="spinning">
      <div class="menuInfoModal">
        <div class="item">
          <a-form>
            <a-form-item name="name" v-bind="validateInfos.name">
              <div class="input-item">
                <span class="text">Menu Name</span>
                <artmisads-input
                  maxlength="100"
                  style="width: 324px"
                  @blur="() => validate('name')"
                  size="middle"
                  v-model:value="modelRef.name"
                />
              </div>
            </a-form-item>
          </a-form>
          <a-form>
            <a-form-item name="path" v-bind="validateInfos.path">
              <div class="input-item">
                <span class="text">Address</span>
                <artmisads-input
                  maxlength="100"
                  style="width: 324px"
                  @blur="() => validate('path')"
                  size="middle"
                  v-model:value="modelRef.path"
                />
              </div>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-spin>
    <template #footer>
      <div class="btn">
        <artmisads-button type="primary" @click="onSave">Save</artmisads-button>
      </div>
    </template>
  </artmisads-modal>
</template>

<script setup>
import { Form } from "ant-design-vue";
import { ref, reactive, computed } from "vue";

const props = defineProps([
  "menuInfo",
  "setShowModal",
  "addMenus",
  "changeMenu",
  "userType"
]);
const spinning = ref(false);

const useForm = Form.useForm;
const modelRef = reactive({
  path: props.menuInfo.path,
  name: props.menuInfo.name,
});

const rulesRef = reactive({
  path: [
    {
      required: true,
      message: "Please fill in path",
      trigger: ["blur"],
    },
  ],
  name: [
    {
      required: true,
      message: "Please fill in name",
      trigger: ["blur"],
    },
  ],
});

const title = computed(() => {
  let text = props.menuInfo.id ?  'Edit Menu' : 'Add Menu';
  return text;
})

const onSave = async () => {
  let data = await validate();
  if (!data.errorFields) {
    data = { ...props.menuInfo, ...data };
    if (props.menuInfo.id) {
      changeMenu(data);
    } else {
      addMenus(data);
    }
  }
}

const { validate, validateInfos } = useForm(modelRef, rulesRef);

const addMenus = async (data) => {
  const paramsData = data;
  paramsData.userType = props.userType;
  paramsData.type = 'directory';
  paramsData.keepAlive = false;
  paramsData.parentId = props.menuInfo.parentId || 0;
  paramsData.sortOrder = props.menuInfo.subSortOrder || 0;
  props.addMenus(paramsData);
};

const changeMenu = async data => {
  const paramsData = data;
  props.changeMenu(paramsData);
};
</script>

<style lang="less" scoped>
.menuInfoModal {
  padding-bottom: 26px;
  .item {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    &:first-child {
      margin-top: 8px;
    }
    :deep(.ant-form) {
      .input-item {
        display: flex;
        flex-direction: column;
        width: 324px;
        .text {
          color: var(--dark-2);
          font-weight: 500;
          line-height: 18px;
          font-size: 13px;
          margin-bottom: 4px;
          display: flex;
          > span {
            color: var(--red-text);
            margin-left: 3px;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
          }
        }
      }
      .ant-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
